export const FOCUSABLE_ELEMENTS = 'button, [href], input, select, textarea, [tabindex]';
